export default require('../otherChains/vizing').default.rpcUrls.default.http[0]